import { all, fork, put, takeEvery } from 'redux-saga/effects';
import accordionstepsSlice from './accordion.slice';
import { AccordionStepsActionTypes } from './common.types';
function* handleNavigateStep(action) {
    // console.log('handleNavigateStep ' + action.payload);
    yield put(accordionstepsSlice.actions.updateStep(action.payload));
}
function* watchFetchRequest() {
    yield takeEvery(AccordionStepsActionTypes.NAVIGATE_STEP, handleNavigateStep);
}
export default function* accordionStepsSaga() {
    yield all([fork(watchFetchRequest)]);
}
